import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-53622165"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = /*#__PURE__*/_createTextVNode()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_icon = _resolveComponent("van-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["headliner", {'headliner-pading':$props.boundary===true}]),
    style: _normalizeStyle({backgroundColor:$props.backgourdColor,})
  }, [
    _createElementVNode("div", {
      style: _normalizeStyle({fontSize:$props.size + 'px',color:$props.colors,})
    }, [
      _createElementVNode("span", { innerHTML: $props.title }, null, 8, _hoisted_1),
      _hoisted_2,
      _createElementVNode("span", null, [
        _renderSlot(_ctx.$slots, "center", {}, undefined, true)
      ])
    ], 4),
    _withDirectives(_createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.skipClick && $setup.skipClick(...args))),
      class: "more"
    }, [
      _createTextVNode(_toDisplayString($props.moreSize) + " ", 1),
      _createVNode(_component_van_icon, {
        name: "arrow",
        color: "#666"
      })
    ], 512), [
      [_vShow, $props.more]
    ])
  ], 6))
}